import {
  ChangePaymentMethodOptions,
  changePaymentMethodV3
} from '@dtx-company/inter-app/src/api/subscription-service/changePaymentMethodV3'
import { Stripe } from '@stripe/stripe-js'
import { confirmPaymentIntentSetupIntent } from '@app/common/src/components/PlanPurchaseExperience/utils/confirmPaymentIntentSetupIntent'
import { confirmationRedirectURL } from '@app/common/src/components/PlanPurchaseExperience/utils/subscriptionService.constant'

interface ChangeExistingPaymentMethodArgs extends ChangePaymentMethodOptions {
  paymentMethodType?: string
  stripe?: Stripe | null
}

export const changeExistingPaymentMethod = async ({
  stripe,
  paymentMethodId,
  subscriptionId,
  token,
  paymentMethodType
}: ChangeExistingPaymentMethodArgs): Promise<void> => {
  const res = await changePaymentMethodV3({
    paymentMethodId: paymentMethodId,
    subscriptionId: subscriptionId,
    token: token
  })
  if (
    res?.clientSecret &&
    res.clientSecret.intentStatus !== 'succeeded' &&
    res.clientSecret.intentStatus !== 'processing' &&
    stripe
  ) {
    await confirmPaymentIntentSetupIntent(
      res.clientSecret,
      stripe,
      confirmationRedirectURL,
      paymentMethodType || 'card'
    )
  }
}
